export const MATERIAL_FIELDS = {
  id: undefined,
  disposalSiteMaterialId: '',
  unitOfMeasure: '',
  quantity: '',
  unitPriceDollars: '',
  feeMaterialId: '',
  useDisposalFeeRate: false,
  rate: '',
  includedTonnage: '',
  useMinimumCharge: false,
  minimumCharge: '',
  overageWeight: '',
  overageFee: '',
}

export const FORM_FIELDS = {
  effectiveDate: null,
  disposalTicketId: '',
  ticketNumber: '',
  disposalSiteId: '',
  materials: [{ ...MATERIAL_FIELDS }],
  taxable: false,
  toBeDeletedMaterials: [],
}
